import PackageContainer from "./PackageContainer";
import { BillingPackage } from "../types/BillingPackage";

interface PackagesViewProps {
    packages: BillingPackage[];
    onEdit: (pkg: BillingPackage) => void;
}

export default function PackagesView({ packages, onEdit }: PackagesViewProps) {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {packages.map((pkg) => (
                <PackageContainer 
                    key={pkg._id}
                    _id={pkg._id}
                    name={pkg.name}
                    price={pkg.price}
                    description={pkg.description}
                    content={pkg.content}
                    duration={pkg.duration}
                    service_name={pkg.service_name}
                    created_at={pkg.created_at}
                    onEdit={onEdit}
                />
            ))}
        </div>
    )
}